import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { CheckoutInitDocument } from "@/core/api/graphql/types";
import type { CartIdFragment, CartExtension, InputCheckoutInitType } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useCheckoutInitMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  return useMutation(CheckoutInitDocument, useCartMutationVariables(cart));
}

export async function checkoutInit(command: InputCheckoutInitType): Promise<CartExtension> {
  const { mutate } = useCheckoutInitMutation();
  const result = await mutate({ command });
  return result!.data! as CartExtension;
}
